import { inject, singleton } from 'tsyringe';
import { notificationsManager } from '@/app/notifications/NotificationsManager';
import { RootTranslatorToken } from '@/common/root';
import type { Translator } from '@/common/root/domain/Translator';
import type { UserNotifier } from '../domain/UserNotifier';

@singleton()
export class AppUserNotifier implements UserNotifier {
  private notification: any | null = null;

  constructor(
    @inject(RootTranslatorToken)
    private readonly translator: Translator,
  ) {}

  async clientUnauthorized(): Promise<void> {
    this.notification = await notificationsManager.fire({
      name: 'network',
      title: this.translator.translate('message.pusher.error_title'),
      message: this.translator.translate('message.pusher.error_content'),
      onClose: () => {
        this.notification = null;
      },
    });
  }

  async closeNotification(): Promise<void> {
    this.notification?.close?.();

    this.notification = null;
  }
}
